"use client";

import Image from "next/image";
import React from "react";
import Link from "next/link";

interface NewsCardProps {
  image: string;
  date: string;
  category: string;
  title: string;
  excerpt: string;
  slug?: string;
}

const NewsCard: React.FC<NewsCardProps> = ({
  image,
  date,
  category,
  title,
  excerpt,
  slug = "news-post",
}) => {
  return (
    <Link href={`/news-pr/${slug}`} className="block group">
      <div className="w-full bg-transparent overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:shadow-xl">
        <div className="relative w-full aspect-video overflow-hidden">
          <Image
            src={image}
            alt={title}
            fill
            className="object-cover transition-transform duration-500 group-hover:scale-110"
            quality={100}
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = '/api/placeholder/400/250';
            }}
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"></div>
        </div>

        <div className="m-4">
          <div className="bg-white/80 backdrop-blur-md px-6 py-4 text-[#333] -mt-16 relative z-50 shadow-[0_4px_8px_0_rgba(0,0,0,0.03)] transition-all duration-300 group-hover:bg-white/90 group-hover:shadow-[0_8px_25px_0_rgba(0,0,0,0.1)]">
            <div className="flex justify-between items-center mb-2">
              <span className="font-semibold text-[#1b1b1b] transition-colors duration-300 group-hover:text-[#272D57]">{date}</span>
              <span className="text-[#5060A1] font-bold transition-all duration-300 group-hover:text-[#E0301E] group-hover:scale-105">{category}</span>
            </div>

            <h3 className="text-[#272D57] text-xl font-semibold leading-tight mb-2 transition-all duration-300 group-hover:text-[#E0301E]">
              {title}
            </h3>
            <p className="text-[#1b1b1b] leading-relaxed transition-colors duration-300 group-hover:text-[#333]">{excerpt}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default NewsCard;